var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "logo-area py-9" },
        [
          _c("v-img", {
            attrs: {
              height: "58",
              contain: "",
              src:
                "https://" +
                _vm.keyword +
                ".libnet.info/images/" +
                _vm.keyword +
                "/card-logo.png"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [{ name: "sticky", rawName: "v-sticky" }],
          staticClass: "search-header"
        },
        [
          _c("div", { staticClass: "search-form-holder" }, [
            _c("div", { staticClass: "basket-area py-8 px-2" }, [
              _c(
                "span",
                {
                  staticClass: "search-header-title display-1 font-weight-light"
                },
                [_vm._v(_vm._s(_vm.$t("reserve.title")))]
              )
            ])
          ])
        ]
      ),
      _c(
        "v-container",
        { staticClass: "room-details mx-auto" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("router-link", { attrs: { to: "/reserve" } }, [
                    _vm._v("back")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _vm.room.images && _vm.room.images.length > 0
                    ? _c(
                        "v-carousel",
                        {
                          staticClass: "room-image",
                          attrs: { "max-width": "520px", height: "400px" }
                        },
                        _vm._l(_vm.room.images, function(item, i) {
                          return _c("v-carousel-item", {
                            key: i,
                            attrs: {
                              src:
                                "https://" +
                                _vm.keyword +
                                ".libnet.info/images/roombooking/" +
                                _vm.keyword +
                                "/" +
                                item,
                              "reverse-transition": "fade-transition",
                              transition: "fade-transition"
                            }
                          })
                        }),
                        1
                      )
                    : _vm.room.image
                    ? _c("v-img", {
                        staticClass: "room-image",
                        attrs: {
                          src:
                            "https://" +
                            _vm.keyword +
                            ".libnet.info/images/roombooking/" +
                            _vm.keyword +
                            "/" +
                            _vm.room.image
                        }
                      })
                    : _vm._e(),
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-list-item",
                        { attrs: { "three-line": "" } },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-subtitle", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getLocationForId(_vm.room.location_id)
                                      .name
                                  )
                                }
                              }),
                              _c("v-list-item-title", {
                                staticClass: "headline mb-1",
                                domProps: { innerHTML: _vm._s(_vm.room.name) }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-avatar",
                            { attrs: { tile: "", width: "60" } },
                            [
                              _c("v-icon", [_vm._v("people_outline")]),
                              _c("span", { staticClass: "pl-1" }, [
                                _vm._v(_vm._s(_vm.roomCapacity))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "grey-lighten-5",
                            "text-color": "black"
                          }
                        },
                        [
                          _c(
                            "v-avatar",
                            { staticClass: "mr-1" },
                            [_c("v-icon", [_vm._v("photo_size_select_small")])],
                            1
                          ),
                          _vm._v(" " + _vm._s(_vm.$t("reserve.roomSize")) + " ")
                        ],
                        1
                      ),
                      _c("v-divider")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "room-details-sidebar" },
                [
                  _vm.clientSettings.rooms_group_billing_enabled &&
                  _vm.userClasses.length > 1
                    ? _c(
                        "v-card",
                        { staticClass: "mb-8 pa-6 elevation-8" },
                        [
                          _c(
                            "v-select",
                            {
                              attrs: {
                                outlined: "",
                                dense: "",
                                "hide-details": true,
                                items: _vm.userClasses,
                                label: _vm.$t("reserve.bookingTypeLabel"),
                                "item-text": "name",
                                "item-value": "id",
                                "prepend-inner-icon": "perm_identity"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.setUserClass($event)
                                }
                              },
                              model: {
                                value: _vm.userClassId,
                                callback: function($$v) {
                                  _vm.userClassId = $$v
                                },
                                expression: "userClassId"
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "d-none d-sm-none d-md-flex",
                                  attrs: { slot: "prepend-inner" },
                                  slot: "prepend-inner"
                                },
                                [_vm._v("perm_identity")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-card",
                    { staticClass: "mb-8 pa-6 elevation-8" },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "max-width": "290px",
                                    "min-width": "290px"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": true,
                                                  "append-icon":
                                                    "arrow_drop_down",
                                                  label: _vm.$t("reserve.date"),
                                                  readonly: ""
                                                },
                                                model: {
                                                  value: _vm.formattedDate,
                                                  callback: function($$v) {
                                                    _vm.formattedDate = $$v
                                                  },
                                                  expression: "formattedDate"
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "d-none d-sm-none d-md-flex",
                                                  attrs: {
                                                    slot: "prepend-inner"
                                                  },
                                                  slot: "prepend-inner"
                                                },
                                                [_vm._v("event")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.showDate,
                                    callback: function($$v) {
                                      _vm.showDate = $$v
                                    },
                                    expression: "showDate"
                                  }
                                },
                                [
                                  _c("v-date-picker", {
                                    attrs: { "no-title": "" },
                                    on: {
                                      input: function($event) {
                                        _vm.showDate = false
                                      }
                                    },
                                    model: {
                                      value: _vm.selectedDate,
                                      callback: function($$v) {
                                        _vm.selectedDate = $$v
                                      },
                                      expression: "selectedDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-1 py-0",
                              attrs: { cols: "auto" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "px-1",
                                  attrs: {
                                    outlined: "",
                                    height: "40",
                                    "min-width": "50",
                                    color: "grey"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.changeDay(-1)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("chevron_left")])],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-1 py-0",
                              attrs: { cols: "auto" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "px-1",
                                  attrs: {
                                    outlined: "",
                                    height: "40",
                                    "min-width": "50",
                                    color: "grey"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.changeDay(1)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("chevron_right")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }